import moment from "moment"
import { IUserContext } from "../../../../system/providers/userContextProvider"

export const convertDoodleDateToUTCFormattedString = (doodleDateStr: string, userCtx: IUserContext): string => {
    const dateUnknown = moment(doodleDateStr)
    const mdate = moment(dateUnknown).tz(userCtx.userTimeZoneId)
    mdate.year(dateUnknown.year())
    mdate.month(dateUnknown.month())
    mdate.day(dateUnknown.day())
    mdate.hour(dateUnknown.hours())
    mdate.minute(dateUnknown.minutes())
    mdate.second(dateUnknown.seconds())
    const formattedDate: string = moment.utc(mdate).format()
    return formattedDate
}